import { cn, paragraph, title } from "@dalmatech/ui"

const container = cn("w-full top-0 z-50 fixed")
const root = cn(
  "flex w-full items-center justify-center gap-6 bg-white p-4 lg:h-20 lg:px-12 lg:py-2 lg:border-b lg:border-neutral-200"
)
const rootAlwaysBordered = cn(
  "flex w-full items-center justify-center gap-6 bg-white p-4 lg:h-20 lg:px-12 lg:py-2 border-b border-neutral-200"
)

// No `relative` here: the SMQ v2 card (absolute, inside this row) must anchor
// to the outer fixed `container` so it lands below the WHOLE navbar block
// (banners + row + mobile progress bar), not below this row only.
const navbar = cn("flex w-full max-w-[84rem] items-center justify-between")

const logoLink = cn(
  "inline-flex focus-visible:rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blurple-600 focus-visible:ring-offset-4"
)
const skeleton = cn("h-6 w-full mx-auto max-w-[42.75rem] hidden lg:block")
const breadcrumb = cn("hidden lg:flex")
const progressBar = cn("flex items-center w-full bg-white")
const completedStepsBar = cn("h-[2px] bg-gradient-to-r from-blurple-500 to-blurple-900")
const uncompletedStepsBar = cn("h-[2px] bg-neutral-100 w-full flex-1")
const activeStep = cn("bg-neutral-25 w-3 h-3 rounded-full flex items-center justify-center")
const activeStepIndicator = cn("bg-black w-[6px] h-[6px] rounded-full")
const multiPetPromoBanner = cn(
  "w-full py-2 px-4 text-center bg-[#E0F5EF] text-[#00855E] h-[2.25rem] min-h-[2.25rem] border-b -mt-1.5 lg:mt-0 border-neutral-200",
  "font-buenosAires font-bold text-[14px] "
)

export {
  activeStep,
  activeStepIndicator,
  breadcrumb,
  completedStepsBar,
  container,
  logoLink,
  multiPetPromoBanner,
  navbar,
  progressBar,
  root,
  rootAlwaysBordered,
  skeleton,
  uncompletedStepsBar,
}
